import React, { useState } from "react";
import { TextField, Button, useMediaQuery } from "@mui/material";
import { Dialog, DialogContent, Stack, Typography } from "@mui/material";
import Repo from "../../repo/Repo";
import TailSpinLoader from "../../components/TailSpinLoader";
import Toast from "../../components/Toast";
import { MailOutline } from "@mui/icons-material";
import { Text } from "../landing page/cards/styles";

const BLOCKED_EMAIL = "info@researchpal.co";
const MIN_MESSAGE_LENGTH = 30;
const MAX_MESSAGE_LENGTH = 500;

function Contact({ open, onClose }) {
  const isSmallScreen = useMediaQuery("(max-width:600px)");
  const [state, setState] = useState({
    loading: false,
    email: "",
    message: "",
    emailError: "",
  });
  const handleInput = (e) => {
    const { name, value } = e.target;
    setState((prev) => {
      let emailError = prev.emailError;
      if (name === "email") {
        emailError =
          value.trim().toLowerCase() === BLOCKED_EMAIL
            ? "Please enter your own personal email."
            : "";
      }
      return { ...prev, [name]: value, emailError };
    });
  };
  const toggle = () => {
    if (!state.loading) {
      onClose();
    }
  };
  const handleSubmit = async () => {
    const cleanedEmail = state.email.trim().toLowerCase();
    const cleanedMessage = state.message.trim();

    if (cleanedEmail === BLOCKED_EMAIL) {
      Toast("error", "Please enter your own personal email.");
      return;
    }

    if (cleanedMessage.length < MIN_MESSAGE_LENGTH) {
      Toast("error", `Message must be at least ${MIN_MESSAGE_LENGTH} characters.`);
      return;
    }

    if (cleanedMessage.length > MAX_MESSAGE_LENGTH) {
      Toast("error", `Message can't exceed ${MAX_MESSAGE_LENGTH} characters.`);
      return;
    }

    setState((prev) => ({ ...prev, loading: true }));
    let { data } = await Repo.email({
      request: {
        method: "sendMessage",
        data: {
          message: cleanedMessage,
          from: cleanedEmail,
        },
      },
    });
    setState((prev) => ({ ...prev, loading: false }));
    if (data.response.data.success === true) {
      Toast("success", "Email Submitted Successfully");
      toggle();
    } else {
      Toast("error", "Email Not Submitted ");
    }
  };
  return (
    <Dialog open={open} onClose={toggle} fullWidth maxWidth="sm">
      <DialogContent>
        <Stack padding="5px" minHeight="300px" spacing={5}>
          <Typography variant="h6" sx={{ textAlign: "center", fontFamily: "Red Hat Display", fontWeight: 600 }}>
            Contact Us
          </Typography>
          <Stack
            spacing={1.6}
            alignItems="center"
            justifyContent="center"
            direction={isSmallScreen ? "column" : "row"}
          >
            <Text sx={{ fontWeight: 700 }}>Get in touch</Text>

            <Stack direction="row" spacing={1}>
              <MailOutline sx={{ mt: "2px", fontSize: "18px" }} />
              <Text>Email : Info@ResearchPal.co</Text>
            </Stack>
          </Stack>
          <TextField
            fullWidth
            name="email"
            label="Enter your email"
            type="email"
            value={state.email}
            onChange={handleInput}
            error={!!state.emailError}
            helperText={state.emailError}
          />
          <TextField
            fullWidth
            multiline
            minRows={6}
            maxRows={7}
            name="message"
            label="Message"
            type="text"
            placeholder="Describe your query in detail..."
            value={state.message}
            onChange={handleInput}
            inputProps={{ maxLength: MAX_MESSAGE_LENGTH }}
            helperText={`${state.message.trim().length}/${MAX_MESSAGE_LENGTH}${state.message.trim().length < MIN_MESSAGE_LENGTH
              ? ` (min ${MIN_MESSAGE_LENGTH})`
              : ""
              }`}
          />
          {state.loading && <TailSpinLoader />}
          {!state.loading && (
            <Stack
              direction={{ xs: "column", sm: "row" }}
              justifyContent="space-between"
              spacing={{ xs: 1 }}
            >
              <Button
                variant="outlined"
                onClick={toggle}
                sx={{
                  color: "#353535",
                  borderColor: "#353535",
                  fontFamily: "Red Hat Display",
                  fontWeight: 600,
                }}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                onClick={handleSubmit}
                sx={{
                  backgroundColor: "#2563EB",
                  fontFamily: "Red Hat Display",
                  fontWeight: 600,
                  boxShadow: "none",
                  "&:hover": {
                    backgroundColor: "#1D4ED8",
                    boxShadow: "none",
                  },
                }}
              >
                Submit
              </Button>
            </Stack>
          )}
        </Stack>
      </DialogContent>
    </Dialog>
  );
}

export default Contact;
